import { Module } from 'vuex'

import { ViewModeType } from '@/domain/value_objects/config/viewModeType'
import { DisplayLanguageType } from '@/domain/value_objects/language/displayLanguageType'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface ConfigState {
  viewMode: ViewModeType
  displayLanguage: DisplayLanguageType
  programLanguage: ProgramLanguageType
  editorFontSize: number
  windowWidth: number
  windowHeight: number
}

export const configStateModule = (): Module<ConfigState, any> => {
  return {
    namespaced: true,
    state: {
      viewMode: 'LIGHT',
      displayLanguage: 'Japanese',
      programLanguage: 'C',
      editorFontSize: 14,
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight
    },
    mutations: {
      setViewMode(state, { viewMode }: { viewMode: ViewModeType }) {
        state.viewMode = viewMode
      },
      setDisplayLanguage(state, { displayLanguage }: { displayLanguage: DisplayLanguageType }) {
        state.displayLanguage = displayLanguage
      },
      setProgramLanguage(state, { programLanguage }: { programLanguage: ProgramLanguageType }) {
        state.programLanguage = programLanguage
      },
      setEditorFontSize(state, { editorFontSize }: { editorFontSize: number }) {
        if (editorFontSize < 8 || editorFontSize > 96) {
          return
        }
        state.editorFontSize = editorFontSize
      },
      setWindowSize(state, { width, height }: { width: number; height: number }) {
        state.windowWidth = width
        state.windowHeight = height
      }
    },
    actions: {
      updateWindowSize({ commit }) {
        commit('setWindowSize', {
          width: window.innerWidth,
          height: window.innerHeight
        })
      }
    },
    getters: {
      viewMode: state => state.viewMode,
      displayLanguage: state => state.displayLanguage,
      programLanguage: state => state.programLanguage,
      editorFontSize: state => state.editorFontSize,
      windowWidth: state => state.windowWidth,
      windowHeight: state => state.windowHeight
    }
  }
}
